import { Briefcase, Calendar, Users, Building2, type LucideIcon } from 'lucide-react';
import type { TipColor } from './QuickTipCard';

export interface TipItem {
  id: string;
  titleKey: string;
  descriptionKey: string;
  tipsKeys: string[];
  icon: LucideIcon;
  color: TipColor;
  actionLabelKey?: string;
  actionPath?: string;
}

export const ADMIN_TIPS: TipItem[] = [
  {
    id: 'services',
    titleKey: 'admin.services.title',
    descriptionKey: 'admin.services.description',
    tipsKeys: [
      'admin.services.tip1',
      'admin.services.tip2',
      'admin.services.tip3',
    ],
    icon: Briefcase,
    color: 'purple',
    actionLabelKey: 'admin.services.action',
    actionPath: '/admin/services',
  },
  {
    id: 'availability',
    titleKey: 'admin.availability.title',
    descriptionKey: 'admin.availability.description',
    tipsKeys: [
      'admin.availability.tip1',
      'admin.availability.tip2',
      'admin.availability.tip3',
    ],
    icon: Calendar,
    color: 'green',
    actionLabelKey: 'admin.availability.action',
    actionPath: '/admin/availability',
  },
  {
    id: 'bookings',
    titleKey: 'admin.bookings.title',
    descriptionKey: 'admin.bookings.description',
    tipsKeys: [
      'admin.bookings.tip1',
      'admin.bookings.tip2',
      'admin.bookings.tip3',
    ],
    icon: Users,
    color: 'blue',
    actionLabelKey: 'admin.bookings.action',
    actionPath: '/admin/bookings',
  },
  {
    id: 'team',
    titleKey: 'admin.team.title',
    descriptionKey: 'admin.team.description',
    tipsKeys: [
      'admin.team.tip1',
      'admin.team.tip2',
      'admin.team.tip3',
    ],
    icon: Building2,
    color: 'orange',
    actionLabelKey: 'admin.team.action',
    actionPath: '/admin/team',
  },
];
